import "./App.css";
import { Handshake } from "lucide-react";
import RegisterForm from "./components/RegisterForm";

const ASSET = "https://pontodecoletacadastro.netlify.app/assets";

const BrandMark = () => (
  <span className="brand-mark">
    <Handshake size={24} color="#102d4f" strokeWidth={2.4} />
  </span>
);

function App() {
  return (
    <div className="App">
      {/* Top bar */}
      <div className="topbar">
        <div className="container">
          <span>◈ Processo oficial</span>
          <span>⌖ Presença no seu bairro</span>
          <span>◷ Cadastro rápido</span>
        </div>
      </div>

      {/* Header */}
      <header className="site-header">
        <div className="container nav">
          <a className="brand" href="#inicio">
            <BrandMark />
            <span>
              <strong>Mercado Livre</strong>
              <small>Cadastro de parceiros</small>
            </span>
          </a>
          <nav className="main-nav">
            <a href="#beneficios">Benefícios</a>
            <a href="#como-funciona">Como funciona</a>
            <a className="nav-button" href="#cadastro">
              Quero participar ↗
            </a>
          </nav>
        </div>
      </header>

      <main>
        {/* Hero */}
        <section id="inicio" className="hero">
          <div className="container">
            <div className="hero-copy">
              <span className="eyebrow">Agências de Mercado Livre</span>
              <h1>Faça seu negócio crescer recebendo e entregando pacotes.</h1>
              <p>
                Transforme seu comércio em um ponto de coleta, atraia mais
                pessoas para a sua loja e crie uma nova oportunidade de receita.
              </p>
              <div className="hero-actions">
                <a className="button" href="#cadastro">
                  Quero ser um ponto de coleta
                </a>
                <a className="button light" href="#beneficios">
                  Conheça os benefícios
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <div className="container benefit-wrap" id="beneficios">
          <div className="benefits">
            <article className="benefit">
              <img src={`${ASSET}/store.jpg`} alt="" />
              <h3>Faça mais pessoas visitarem sua loja</h3>
              <p>Seja uma opção prática para quem mora ou trabalha na sua região.</p>
            </article>
            <article className="benefit">
              <img src={`${ASSET}/earnings.jpg`} alt="" />
              <h3>Gere receita extra para o seu negócio</h3>
              <p>Receba repasses pelas operações realizadas no seu ponto.</p>
            </article>
            <article className="benefit">
              <img src={`${ASSET}/no-investment@x1.jpg`} alt="" />
              <h3>Participe sem custos ou esforço</h3>
              <p>Você usa a estrutura que já tem e recebe orientação para começar.</p>
            </article>
          </div>
        </div>

        {/* Split 1 */}
        <section>
          <div className="container split">
            <div className="art">
              <img
                src={`${ASSET}/agency-client-interaction@x1.jpg`}
                alt="Pessoas retirando e entregando pacotes em uma loja"
              />
            </div>
            <div>
              <span className="section-kicker">Uma parceria para o bairro</span>
              <h2>Vire a loja de confiança da sua região</h2>
              <p>
                Muitas pessoas vão passar na sua loja para entregar ou retirar
                pacotes. Você entra para uma rede de pontos de coleta e torna o
                dia a dia dos clientes mais simples.
              </p>
              <a className="button" href="#cadastro">
                Quero me cadastrar
              </a>
            </div>
          </div>
        </section>

        {/* Tasks */}
        <section className="paper-section tasks" id="como-funciona">
          <div className="container">
            <span className="section-kicker">Novas possibilidades</span>
            <h2 className="section-title">
              Aumente sua receita somando novas tarefas aos serviços que você já
              oferece
            </h2>
            <div className="task-grid">
              <article className="task">
                <img
                  src={`${ASSET}/seller-delivery-PT.jpg`}
                  alt="Recebimento de pacote de vendedor"
                />
                <h3>Receber pacotes de vendedores</h3>
              </article>
              <article className="task">
                <img
                  src={`${ASSET}/package-handoff-PT.jpg`}
                  alt="Entrega de pacote entre pessoas"
                />
                <h3>Entregar pacotes para compradores</h3>
              </article>
              <article className="task">
                <img
                  src={`${ASSET}/delivery-to-customer-PT.jpg`}
                  alt="Entrega de pacote ao cliente"
                />
                <h3>Fazer entregas de pacotes a domicílio</h3>
              </article>
            </div>
          </div>
        </section>

        {/* Split 2 */}
        <section>
          <div className="container split">
            <div>
              <span className="section-kicker">Comece com o que você já tem</span>
              <h2>Participe sem investir dinheiro</h2>
              <p>
                Você só precisa ter espaço na sua loja para armazenar pacotes.
                Não será necessário adaptar o local ou comprar equipamentos
                extras.
              </p>
              <a className="button" href="#cadastro">
                Ver requisitos e cadastrar
              </a>
            </div>
            <div className="art">
              <img
                src={`${ASSET}/no-investment@x1.jpg`}
                alt="Ilustração de uma pessoa recebendo pacotes no comércio"
              />
            </div>
          </div>
        </section>

        {/* Requirements */}
        <section className="requirements">
          <div className="container split">
            <div className="art">
              <img
                src={`${ASSET}/agency-overview@x1.png`}
                alt="Comerciante em uma loja"
              />
            </div>
            <div>
              <span className="section-kicker">O que você precisa</span>
              <h2>Pronto para ser um ponto de coleta?</h2>
              <ul className="checklist">
                <li>Ter uma loja física aberta ao público em horário comercial.</li>
                <li>Ter CNPJ ou atuar como pessoa física, conforme a análise do cadastro.</li>
                <li>Ter uma conta bancária para receber os repasses.</li>
                <li>Ter espaço coberto e seguro para armazenar os pacotes.</li>
                <li>Ter celular ou computador para acompanhar as operações.</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Steps */}
        <section>
          <div className="container">
            <span className="section-kicker">Do cadastro à operação</span>
            <h2 className="section-title">Como funciona</h2>
            <div className="steps">
              <article className="step">
                <b>1</b>
                <h3>Preencha seu cadastro</h3>
                <p>Conte para a gente sobre você, seu negócio e o espaço disponível.</p>
              </article>
              <article className="step">
                <b>2</b>
                <h3>Nossa equipe analisa</h3>
                <p>Verificamos localização, estrutura e capacidade de atendimento.</p>
              </article>
              <article className="step">
                <b>3</b>
                <h3>Entramos em contato</h3>
                <p>Depois da análise, alguém da equipe fala com você para explicar os próximos passos.</p>
              </article>
            </div>
          </div>
        </section>

        {/* Register */}
        <section className="register" id="cadastro">
          <div className="container">
            <div className="register-heading">
              <span className="section-kicker">Próximo passo</span>
              <h2 className="section-title">Preencha seu cadastro</h2>
              <p>
                É rápido, gratuito e sem burocracia. Depois do envio, alguém da
                nossa equipe entrará em contato com você.
              </p>
            </div>
            <RegisterForm />
          </div>
        </section>

        {/* FAQ */}
        <section className="faq">
          <div className="container">
            <span className="section-kicker">Dúvidas comuns</span>
            <h2 className="section-title">Perguntas frequentes</h2>
            <details open>
              <summary>O que é um ponto de coleta?</summary>
              <p>
                É um comércio parceiro que recebe, guarda temporariamente e
                entrega pacotes do Mercado Livre.
              </p>
            </details>
            <details>
              <summary>Preciso investir para participar?</summary>
              <p>
                Não. A proposta é usar a estrutura que você já possui, desde que
                ela atenda aos requisitos da análise.
              </p>
            </details>
            <details>
              <summary>Como recebo os repasses?</summary>
              <p>
                Os repasses são feitos em conta bancária, conforme as operações e
                as condições da parceria.
              </p>
            </details>
            <details>
              <summary>Depois do cadastro, o que acontece?</summary>
              <p>
                Nossa equipe analisa as informações e entra em contato para
                explicar os próximos passos.
              </p>
            </details>
          </div>
        </section>

        {/* Final CTA */}
        <section className="final-cta">
          <div className="container">
            <span className="section-kicker">Sua loja pode fazer parte</span>
            <h2>Pronto para ser um ponto de coleta?</h2>
            <p>
              Preencha o cadastro. Nossa equipe vai analisar as informações e
              entrar em contato para explicar os próximos passos.
            </p>
            <a className="button" href="#cadastro">
              Quero me cadastrar ↗
            </a>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="container">
          <strong>Mercado Livre · Cadastro de parceiros</strong>
          <span>Ponto de Coleta — recebimento e entrega de pacotes.</span>
        </div>
      </footer>
    </div>
  );
}

export default App;
